import { Cheque } from '../../../../models/cheque';
import { Component, Inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CDSMask } from '@app/utils/cds-mask';
import { ToastrService } from 'ngx-toastr';
import { Conta } from '@app/models/conta.model';
import { UtilitarioService } from '@app/services/utilitario.service';
import { MovimentacaoFinanceira } from '@app/models/movimentacao-financeira.model';
import { LancamentoService } from '@app/services/lancamento.service';
import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { UsuarioTipoService } from '@app/services/usuario-tipo.service';
import { ParticipanteService } from '@app/services/participante.service';

@Component({
  selector: 'app-lancamento-form',
  templateUrl: './lancamento-form.component.html',
})
export class LancamentoFormComponent implements OnInit {

  movimentacao: MovimentacaoFinanceira = new MovimentacaoFinanceira();

  cdsMask: CDSMask = new CDSMask();
  lstErros: string[] = [];
  carregandoDados = true;
  aguardandoSolicitacao = false;

  titulo: string;
  conta: Conta = new Conta();

  lstBanco: IdDescricao[] = [];
  lstConta: IdDescricao[];
  _lstFormaDePagamento: IdDescricao[] = [];
  lstFormaDePagamento: IdDescricao[] = [];
  lstTipoDR: IdDescricao[] = [];
  lstUnidades: IdDescricao[] = [];
  novo: boolean;

  transferencia: boolean;
  cheque: boolean = false;

  acessoOutrasUnidades: boolean = false;
  movimentarTodosOsCaixas: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private movimentoService: LancamentoService,
    private consultasService: ConsultasService,
    private usuarioTipoService: UsuarioTipoService,
    private participanteService: ParticipanteService,
    @Inject(ToastrService) private toastr: ToastrService
  ) {
    this.movimentacao = new MovimentacaoFinanceira();
    this.movimentacao.Id = 0;
    this.movimentacao.Valor = 0;
    this.movimentacao.ContaId = 0;
    this.movimentacao.CreditoDebito = 'C';
    this.movimentacao.FormaDePagamentoId = null;
    this.movimentacao.DemonstrativoDeResultadoId = null;
  }


  ngOnInit() {
    this.route.params.subscribe(
      (params: any) => {
        const id = params['id'];
        this.titulo = id ? 'Editar lançamento' : 'Novo lançamento';
        // novo
        if (!id) {
          this.movimentacao.ContaId = 0;
          this.movimentacao.CreditoDebito = 'C';
          this.movimentacao.UnidadeId = Number(UtilitarioService.retornaUnidadeUsuario());
          this.novo = true;
        }
        this.carregaDadosInicias(id);
      });

    this.consultasService.consultar('UNIDADE_S_RATEIO').subscribe(data => this.lstUnidades = data);
    this.usuarioTipoService.verificaPermissaoUsuario().subscribe(
      (permissoes: any) =>{
        this.acessoOutrasUnidades = permissoes.find(x => x.Descricao == 'VisualizarOutrasUnidades').Selecionado;
      })
      this.participanteService.verificaPermissaoUsuario(0, 'MovimentarTodosOsCaixas')
        .subscribe(data => {
          this.movimentarTodosOsCaixas = data;
          this.consultasService.consultar('CONTA').subscribe((data) => (this.lstConta = data));
        },
        error => this.consultasService.consultar('CONTA_USUARIO').subscribe((data) => (this.lstConta = data))
      );
  }

  async carregaDadosInicias(id: number) {

    const chamadas = [
      this.consultasService.consultar('CONTA'),
      this.consultasService.consultar('BANCO'),
      this.consultasService.consultar('FORMADEPAGAMENTO'),
      this.consultasService.consultar('DR')
    ];

    if (id) {
      chamadas.push(this.movimentoService.obterPorId(id));
    }


    const [data1, data2, data3, data4, data5] = await Promise.all(chamadas);

    data1.toPromise().then(data => this.lstConta = <IdDescricao[]>data);
    data2.toPromise().then(data => this.lstBanco = <IdDescricao[]>data);
    data3.toPromise().then(data => {
      this._lstFormaDePagamento = <IdDescricao[]>data;
      this.obterFormaDePagamentoPorTipo();
    });
    data4.toPromise().then(data => this.lstTipoDR = <IdDescricao[]>data);
    if (id) {
      data5.toPromise().then(data => {
        this.movimentacao = <MovimentacaoFinanceira>data;
        this.movimentacao.DataCompetencia = this.movimentacao.DataCompetencia.split('T')[0];
        this.movimentacao.DataLancamento = this.movimentacao.DataLancamento.split('T')[0];
      });
    }

    this.carregandoDados = false;

    const hoje = new Date();
    (<HTMLInputElement>document.getElementById('DataLancamento')).value = hoje.toISOString().split('T')[0];
    (<HTMLInputElement>document.getElementById('DataCompetencia')).value = hoje.toISOString().split('T')[0];
  }

  validaCheque(movimentacao: MovimentacaoFinanceira) {
    if (!movimentacao.Cheque.BancoId || movimentacao.Cheque.BancoId < 1) {
      this.toastr.error('Banco  do cheque não informado');
      this.aguardandoSolicitacao = false;
      return false;
    }

    if (!movimentacao.Cheque.Agencia) {
      this.toastr.error('Agência do cheque não informada.');
      this.aguardandoSolicitacao = false;
      return false;
    }

    if (!movimentacao.Cheque.Conta) {
      this.toastr.error('Conta  do cheque não informada.');
      this.aguardandoSolicitacao = false;
      return false;
    }

    if (!movimentacao.Cheque.ChequeNum) {
      this.toastr.error('Número do cheque não informado.');
      this.aguardandoSolicitacao = false;
      return false;
    }

    if (!movimentacao.Cheque.Titular) {
      this.toastr.error('Titular do cheque não informado.');
      this.aguardandoSolicitacao = false;
      return false;
    }

    if (!movimentacao.Cheque.DataEmissao) {
      this.toastr.error('Data de emissão do cheque não informada.');
      this.aguardandoSolicitacao = false;
      return false;
    }

    if (!movimentacao.Cheque.DataVencimento) {
      this.toastr.error('Data de vencimento do cheque não informada.');
      this.aguardandoSolicitacao = false;
      return false;
    }

    this.movimentoService.gravar(movimentacao)
      .toPromise().then(() => this.redirecionar(),
        (data: any) => {
          if (data.error) {
            this.lstErros = data.error.errors;
          } else {
            this.lstErros.push('ocorreu um erro, tente novamente');
          }
          this.aguardandoSolicitacao = false;
        });
  }

  verificaCadastrarCheque(formaDePagamentoId: number){
    this.cheque = this.lstFormaDePagamento.filter(x => x.Id === formaDePagamentoId)[0].Extra2;
    this.movimentacao.Cheque = this.cheque ? new Cheque() : null;
  }

  chequeProprio(){
    const contaEncontrada = this.lstConta.find(x => x.Id === this.movimentacao.ContaId);
    if (contaEncontrada) {
      this.movimentacao.Cheque.BancoId = contaEncontrada.Extra1;
      this.movimentacao.Cheque.Agencia = contaEncontrada.Extra2;
      this.movimentacao.Cheque.Conta = contaEncontrada.Extra3;
      this.movimentacao.Cheque.Titular = contaEncontrada.Extra4;
    }

  }

  obterFormaDePagamentoPorTipo() {
    this.lstFormaDePagamento = this._lstFormaDePagamento.filter(x => x.Extra1 === 'A' || x.Extra1 === this.movimentacao.CreditoDebito);
    if (this.movimentacao.Id === 0) {
      this.movimentacao.FormaDePagamentoId = null;
    }
  }

  gravar() {
    this.aguardandoSolicitacao = true;
    this.lstErros = [];
    const movimentacao = { ...this.movimentacao };
    movimentacao.DemonstrativoDeResultado = null;
    
    if(this.cheque){
      this.validaCheque(movimentacao);
    } 
    else{
      this.movimentoService.gravar(movimentacao)
      .toPromise().then(() => this.redirecionar(),
        (data: any) => {
          if (data.error) {
            this.lstErros = data.error.errors;
          } else {
            this.lstErros.push('ocorreu um erro, tente novamente');
          }
          this.aguardandoSolicitacao = false;
        });
    }
  }

  btnVoltar() {
    window.history.go(-1);
  }

  private redirecionar() {
    this.router.navigate(['/financeiro/lancamento', this.movimentacao.ContaId, this.movimentacao.DataCompetencia]);
  }

  searchCallback = () => true;

}
